export default __webpack_public_path__ + "static/media/bespay-api.f1562113.pdf";